import {IStore} from "modules/types";
import {createSelector} from "reselect";

export const getErrorState = (state: IStore) => state.error;

export const getErrorMessage = createSelector(getErrorState, ({message}) => message);
